import { Select } from "@mantine/core";
import { useLocation, useNavigate, useParams } from "@remix-run/react";

import FrFlag from "~/assets/icons/fr.svg?react";
import EnFlag from "~/assets/icons/gb.svg?react";
import { useTranslation } from "~/hooks/use-typed-translation";

interface LanguageToggleProps {
  className?: string;
}

export const LanguageToggle = ({ className }: LanguageToggleProps) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { lang } = useParams();
  // console.log(lang);

  const selectedLang = i18n.language?.toLowerCase() ?? "en";
  const CurrentFlag = selectedLang === "fr" ? FrFlag : EnFlag;

  const handleLanguageChange = (val: string | null) => {
    if (!val) return;
    i18n.changeLanguage(val);
    // Construct the new URL path with the selected language
    let newPath;
    if (lang) {
      // If lang is present, replace it in the URL
      newPath = location.pathname.replace(/^\/[a-z]{2}/, `/${val}`);
    } else {
      // If lang is not present, prepend it to the URL
      newPath = `/${val}${location.pathname}`;
    }
    // Append the existing search parameters
    newPath += location.search;
    navigate(newPath, {
      replace: true,
      state: location.state,
      preventScrollReset: true,
    });
  };

  return (
    <Select
      className={className}
      data={[
        { label: "EN", value: "en" },
        { label: "FR", value: "fr" },
      ]}
      value={selectedLang}
      onChange={(_val, option) => handleLanguageChange(option.value)}
      leftSection={<CurrentFlag style={{ width: 20, height: 20 }} />}
      maw={90}
    />
  );
};
